define('AwaLabs.SearchSpring.Shopping.EntryPoint', [
    'SearchSpring.SiteSearch.View',
    'SearchSpring.Search.View',
    'SearchSpring.Tracker'
], function AwaLabsSearchSpringShoppingEntryPoint(
    SiteSearchView,
    SearchSpringBrowseView,
    Tracker
) {
    'use strict';

    return {
        mountToApp: function mountToApp(application) {
            var pageType = application.getComponent('PageType');
            var layout = application.getComponent('Layout');
            pageType.registerPageType({
                name: 'facet-browse',
                routes: ['search'],
                view: SearchSpringBrowseView
            });

            layout.addChildViews('Backbone.View', {
                'SiteSearch': {
                    'SiteSearch': {
                        childViewIndex: 0,
                        childViewConstructor: function childViewConstructor() {
                            return new SiteSearchView({
                                application: application
                            });
                        }
                    }
                }
            });
            Tracker.mountToApp(application);
        }
    };
});
